import { createPortal } from 'react-dom';
import clsx from 'clsx';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { ACCESS_TYPES } from '../../store/investor/constants';
import { MobileTabConfig } from './types';
import { MOBILE_TAB_CONFIG } from './MobileBottomTabs.constants';
import styles from './MobileBottomTabs.module.scss';

const MobileBottomTabs = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const permissions = useAppSelector((state) => state.investor.permissions);

    const visibleTabs = MOBILE_TAB_CONFIG.filter((tab) => {
        if (!tab.permissionKey) return true;
        const perm = permissions[tab.permissionKey];
        return perm !== ACCESS_TYPES.LOCKED && perm !== ACCESS_TYPES.HIDDEN;
    });

    const activeTab = visibleTabs.find((tab) => location.pathname.includes(tab.route))?.key || visibleTabs[0]?.key;

    const handleTabChange = (tab: MobileTabConfig) => {
        navigate(`../${tab.route}`, { relative: 'path' });
    };

    if (visibleTabs.length === 0) return null;

    return createPortal(
        <div className={styles.BottomTabs}>
            {visibleTabs.map((tab) => {
                const isActive = activeTab === tab.key;
                return (
                    <button
                        key={tab.key}
                        type="button"
                        className={clsx(styles.Tab, {
                            [styles.Active]: isActive,
                        })}
                        onClick={() => handleTabChange(tab)}
                    >
                        <img className={styles.Icon} src={isActive ? tab.activeIcon : tab.icon} alt={tab.label} height={20} width={20} />
                        <span className={styles.Label}>{tab.label}</span>
                    </button>
                );
            })}
        </div>,
        document.body,
    );
};

export default MobileBottomTabs;
